import axios from 'axios'; 
import { TokenOpts } from '@/models/authentication/authResultModel';  
import ApiURLs from '@/ApiURLs';
import router from './router';
import customLocalStorage from '@/config/customLocalStorage';
import customJSON from '@/config/customJSON';

export default class Interceptor {
    private static isRefreshing = false;
    private static delay = (interval:number) => new Promise(resolve => setTimeout(resolve, interval));
    private static isPublicUrl = (serchingUrl:string|undefined) => {
      const publicUrls = [
        '/account/login',
        '/account/register',
        '/policies/getPolicy', 
        '/account/forgotPassword', 
        '/account/resetPassword', 
        '/account/confirmemail', 
        '/account/validateEmail',
        '/account/validateUserName',
        '/account/validateUserNameEmail',
        '/account/resendActivation',
        '/auth/getUserByUserName'
      ]

      return publicUrls.some(url => serchingUrl?.includes(url));
    } 
 
    public static setup() : void {   
      axios.interceptors.request.use(async (config) => { 
        const tokenStr:string = customLocalStorage.getItem("token") as string;

        let token:TokenOpts = customJSON.parse(tokenStr,true);  
        
        if (config.url === ApiURLs.refreshTokenUrl) {
          config.data = {refreshToken:token?.refreshToken, accessToken:token?.accessToken};
        }

        if (Interceptor.isPublicUrl(config.url) || config.url  === ApiURLs.refreshTokenUrl) {
          return config;
        }

        if (Interceptor.isRefreshing) {
          do {
            await Interceptor.delay(1000);
          }

          while (Interceptor.isRefreshing); 

          const newtokenStr:string = customLocalStorage.getItem("token") as string;
          const newToken:TokenOpts = customJSON.parse(newtokenStr, true);
          token = newToken;
        }

        let res:any = null;        
        if (new Date(token?.accessTokenExpiry) < new Date() && !Interceptor.isRefreshing) {
          Interceptor.isRefreshing = true;
          res = await axios.post(ApiURLs.refreshTokenUrl, {
            refreshToken:token?.refreshToken,
            accessToken:token?.accessToken
          }
          );
        }

        const newToken:TokenOpts = customJSON.parse(customLocalStorage.getItem("token") as string, true);
        config.headers!.Authorization = "Bearer " + newToken?.accessToken;

        return config;
      }, function (error) {
        return Promise.reject(error);
      });
  
      axios.interceptors.response.use(
        async (response) => {
          if (response.config.url === ApiURLs.refreshTokenUrl  || response.config.url === ApiURLs.login) {
            const token:TokenOpts = response.config.url === ApiURLs.refreshTokenUrl? response.data:response.data.token; 

            customLocalStorage.setItem("token", JSON.stringify(token));
            Interceptor.isRefreshing = false;
          }

          return response;
        },
        async (error) => {
          const failedRequest = error.config;

          if (error.response === undefined) {
            router.push({
              name: "error",
              params: { code: '', message: error.message + error.stack }
            });
          }

          if (
              (error.response.status == 400)
                || (error.response.status == 401)
                || (error.response.status == 403)
              ) {
                router.push({
                  name: "login",
                  params: { }
                });
          }
          else {
            if (error.response.status >= 500) {
              router.push({
                name: "error",
                params: { code: error.response.status, message: error.response.data.detail }
              });
            }
  
            const isPublicUrl = Interceptor.isPublicUrl(failedRequest.url);
  
            if (!isPublicUrl && error.response.status >= 400) {
              return router.push({
                name: "error",
                params: { code: error.response.status, message: error.response.data.detail }
              });
            }
          }          

          return Promise.reject(error); 
        })
    }
}